import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Collapse,
  Box,
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { formatMoney, getDivisionName } from "../../../constants/utils";
import moment from "moment";

// Define the months to show (April 2024 to April 2025)
const generateMonthList = () => {
  /* const months = [];
  let current = moment("2024-04-01");
  for (let i = 0; i <= 12; i++) {
    months.push(current.format("MMMM YYYY"));
    current.add(1, "month");
  }
  return months; */
  const months = [];
  let current = moment("2026-03-01"); // Start from April 2025
  for (let i = 0; i <= 12; i++) {
    months.push(current.format("MMMM YYYY"));
    current.subtract(1, "month"); // Move backward in time
  }
  return months;
};

const monthList = generateMonthList();

const CollapsibleTableForHistory = ({ modalData, showDetailedView }) => {
  //modalData = modalData.filter((item) => item.customerCode === "0001005583");
  // Group data by customer name and date
  //console.log(modalData, "modalData od history");
  /* const groupedData = modalData.reduce((acc, item) => {
    const customer = item.customerName;
    const month = moment(item.createdDate).format("MMMM YYYY");
    if (!acc[customer]) {
      acc[customer] = {};
    }
    acc[customer][month] = formatMoney(item.overdue.toFixed(0));
    return acc;
  }, {}); */

  const groupedData = modalData.reduce((acc, item) => {
    const customer = item.customerName;
    const month = moment(item.createdDate).format("MMMM YYYY");

    if (!acc[customer]) {
      acc[customer] = {
        customerName: item.customerName,
        customerCode: item.customerCode,
        paymentClass: item.paymentClass,
        averagePaymentDays: item.averagePaymentDays,
        //division: item.division,
        months: {},
      };
    }
    // Sum overdue if month already exists
    const previous = acc[customer].months[month]
      ? parseInt(acc[customer].months[month].replace(/,/g, ""))
      : 0;

    acc[customer].months[month] = formatMoney(previous + item.overdue);
    return acc;
    /* acc[customer].months[month] = formatMoney(item.overdue.toFixed(0));
    return acc; */
  }, {});

  const monthListTableHeader = showDetailedView
    ? monthList
    : [
        "Live (Mar 2026)",
        "Prev Month (Feb 2026)",
        "Prev Quarter (Dec 2025)",
        "Prev Year (Mar 2025)",
        "Last Year L2L(Mar 2025)",
      ];

  const monthListTableBody = showDetailedView
    ? monthList
    : [
        "March 2026",
        "February 2026",
        "December 2025",
        "March 2025",
        "March 2025",
      ];

  return (
    <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell
              style={{
                backgroundColor: "black",
                color: "white",
                fontWeight: "bold",
                minWidth: 180,
              }}
            >
              Customer
            </TableCell>
            <TableCell
              style={{
                backgroundColor: "black",
                color: "white",
                fontWeight: "bold",
                minWidth: 120,
              }}
            >
              Customer Code
            </TableCell>
            {monthListTableHeader.map((month) => (
              <TableCell
                key={month}
                style={{
                  backgroundColor: "black",
                  color: "white",
                  fontWeight: "bold",
                  minWidth: 120,
                }}
              >
                {month}
              </TableCell>
            ))}
            {showDetailedView && (
              <>
                <TableCell
                  style={{
                    backgroundColor: "black",
                    color: "white",
                    fontWeight: "bold",
                    minWidth: 120,
                  }}
                >
                  Payment Class
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: "black",
                    color: "white",
                    fontWeight: "bold",
                    minWidth: 120,
                  }}
                >
                  Avg Payment Days
                </TableCell>
              </>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.entries(groupedData)
            .filter(([_, data]) => {
              // Get only the months we care about (based on detailed or summary view)
              const monthsToCheck = monthListTableBody;

              // Sum all the amounts for those months
              const total = monthsToCheck.reduce((sum, month) => {
                const val = data.months[month];
                if (!val || val === "-") return sum;

                const parsed = parseInt(val.replace(/,/g, ""), 10);
                return sum + parsed;
              }, 0);

              return total > 0; // Keep row only if total is greater than 0
            })
            .map(([customer, data]) => (
              <TableRow key={customer}>
                <TableCell>{customer}</TableCell>
                <TableCell>{data.customerCode || "-"}</TableCell>
                {/* <TableCell>{getDivisionName(data.division) || "-"}</TableCell> */}
                {/* {monthListTableBody.map((month) => (
                  <TableCell key={month}>
                    {console.log(month, ">>>", data.months[month])}
                    {data.months[month] || "-"}
                  </TableCell>
                ))} */}
                {!showDetailedView
                  ? monthListTableBody.map((month, index) => (
                      <TableCell key={month + index}>
                        {data.months[month] || "-"}
                      </TableCell>
                    ))
                  : (() => {
                      const renderedMonths = new Set();

                      return monthListTableBody.map((month, index) => {
                        if (renderedMonths.has(month)) {
                          return <TableCell key={month + index}>-</TableCell>;
                        }

                        renderedMonths.add(month);

                        return (
                          <TableCell key={month + index}>
                            {data.months[month] || "-"}
                          </TableCell>
                        );
                      });
                    })()}
                {showDetailedView && (
                  <>
                    <TableCell>{data.paymentClass || "-"}</TableCell>
                    <TableCell>{data.averagePaymentDays || "-"}</TableCell>
                  </>
                )}
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CollapsibleTableForHistory;
